import React from "react";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();
  const logo = process.env.PUBLIC_URL + "/images/logo.png";

  return (
    <footer className="app-footer" translate="no">
      <div className="app-footer__inner">
        <div className="app-footer__brand">
          <img src={logo} alt="Smile2Steps logo" className="app-footer__logo" />
          <p className="app-footer__tagline">
            Supporting every child&rsquo;s developmental journey, one milestone
            at a time.
          </p>
        </div>

        <nav className="app-footer__links" aria-label="Footer">
          <a href="mailto:smile2steps.ai@gmail.com">Contact</a>
          <a
            href="https://smile2steps.ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            About
          </a>
          <a href="#privacy">Privacy</a>
          <a href="#terms">Terms</a>
        </nav>
      </div>

      <div className="app-footer__bar">
        <span>&copy; {year} Smile2Steps. All rights reserved.</span>
        <span className="app-footer__made">Made with care for families.</span>
      </div>
    </footer>
  );
};

export default Footer;
